import React from 'react';

import {AlertActions} from 'presentation/components';
import {AuthorizationsEnum, ChatRoomsEnum} from 'presentation/constants';
import {useGetEndpointUrl} from 'presentation/hooks/useGetEndpointUrl';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {ExternalServicesTitlesEnum} from 'presentation/pages/private/hooks/useServicesList/types';
import {translations} from 'presentation/translations-new';
import {useLocation, useNavigate} from 'react-router-dom';
import {FlowEnum} from '../../../constants';

import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {NeedAuthActionsProps} from '../types';

const {authorizations} = translations['pt-br'].privateFlow.therapyBooking.actionText;
const {speakToOnlineSupport} = translations['pt-br'].commons;

export function NeedAuthActions({handleAction, flowType}: NeedAuthActionsProps) {
	const bookingFlowStep = useBookingFlowStepsStore(state => state.bookingStep);

	const navigate = useNavigate();
	const {pathname} = useLocation();

	const {isLoading} = useGetEndpointUrl(ExternalServicesTitlesEnum.AUTHORIZATION_REQUEST);

	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const isOdonto = flowType === FlowEnum.ODONTO;
	const isExam = flowType === FlowEnum.EXAM;

	async function handleCallChatRoom() {
		let type = ChatRoomsEnum.APP;

		if (isOdonto) {
			type = ChatRoomsEnum.ODONTO;
		}

		if (isExam) {
			type = ChatRoomsEnum.EXAMS;
		}
		await callChatRoom(type);
		handleAction();
	}

	const handleGetAuthorizations = async () => {
		navigate(AuthorizationsEnum.AUTHORIZATIONS, {
			state: {
				pathname,
				step: bookingFlowStep,
			},
		});
	};

	return (
		<AlertActions
			flexDirection="column"
			primaryBtnVariant="outlined"
			primaryAction={handleCallChatRoom}
			primaryText={speakToOnlineSupport}
			secondaryBtnVariant="contained"
			secondaryAction={handleGetAuthorizations}
			secondaryText={authorizations}
			isDisabled={callChatRoomIsLoading}
			isLoading={callChatRoomIsLoading}
			isDisabledSecondary={isLoading}
			isLoadingSecondary={isLoading}
		/>
	);
}
